import React from 'react';
import '../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GradeManager from "../../../../components/Grade";
import {getSchoolYear} from "../../../../utils/authority";
import FeeItemController from "../../../../services/system/fee-item/fee-item-controller";
import Utils from "../../../../utils/utils";

class ModalCreateFeeItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            priceMonth: 0,
            priceSemester: 0,
            priceYear: 0,
            note: "",
            state: "ACTIVE",
        };
    }
    createFeeItem = () => {
        let priceMonth = parseFloat(this.state.priceMonth.toString().replaceAll(",", ""))
        let priceSemester = parseFloat(this.state.priceSemester.toString().replaceAll(",", ""))
        let priceYear = parseFloat(this.state.priceYear.toString().replaceAll(",", ""))
        if (this.state.name.length < 3){
            toast.error("Tên khoản phí phải lớn hơn 3 ký tự", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else if (priceMonth < 1000){
            toast.error("Giá phải lớn hơn 1000", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else if (priceSemester < 1000){
            toast.error("Giá phải lớn hơn 1000", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else if (priceYear < 1000){
            toast.error("Giá phải lơn hơn 1000", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else {
            let payload = {
                "name": this.state.name,
                "priceMonth": priceMonth,
                "priceSemester": priceSemester,
                "priceYear": priceYear,
                "note": this.state.note,
                "state": this.state.state,
                "yearId": parseInt(getSchoolYear()),
            }
            FeeItemController.create(payload, res => {
                if (res.success) {
                    toast.success("Thêm giá thành công!", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 3000
                    });
                    this.props.onHide();
                    this.props.onRefresh()
                } else {
                    toast.error("Có lỗi xảy ra!", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 3000
                    });
                }
            })
        }
    }
    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Thêm cấu hình khoản phí</b></h1>
                        </div>
                        <div className='d-flex justify-content-center mt-12 mb-12'>
                            <div className="row">

                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Tên khoản phí(<span  style={{color: "red",}}>*</span>)</label>
                                    <input
                                        maxLength={255}
                                        type="text"
                                        placeholder="Nhập tên"
                                        className="form-control shadow-none"
                                        value={this.state.name}
                                        onChange={(event) => {
                                            this.setState({
                                                name: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Giá theo tháng(<span  style={{color: "red",}}>*</span>)</label>
                                    <input
                                        placeholder="Nhập giá"
                                        maxLength={255} type="text"
                                        className="form-control shadow-none"
                                        value={Utils.formatMoney(this.state.priceMonth)}
                                        onChange={(event) => {
                                            this.setState({
                                                priceMonth: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Giá theo kỳ(<span  style={{color: "red",}}>*</span>)</label>
                                    <input
                                        placeholder="Nhập giá"
                                        maxLength={255} type="text"
                                        className="form-control shadow-none"
                                        value={Utils.formatMoney(this.state.priceSemester)}
                                        onChange={(event) => {
                                            this.setState({
                                                priceSemester: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Giá theo năm(<span  style={{color: "red",}}>*</span>)</label>
                                    <input
                                        placeholder="Nhập giá"
                                        maxLength={255} type="text"
                                        className="form-control shadow-none"
                                        value={Utils.formatMoney(this.state.priceYear)}
                                        onChange={(event) => {
                                            this.setState({
                                                priceYear: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Chú thích</label>
                                    <input
                                        placeholder="Nhập chú thích"
                                        maxLength={255} type="text"
                                        className="form-control shadow-none"
                                        value={this.state.note}
                                        onChange={(event) => {
                                            this.setState({
                                                note: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-12 d-flex mb-2">
                                    <label className="col-6 label-item pl-0">Trạng thái</label>
                                    <select
                                        className="form-control kt-input pd-4-input hei-input"
                                        value={this.state.state}
                                        onChange={(e) => {
                                            this.setState({
                                                state: e.target.value,
                                            })
                                        }}
                                    >
                                        <option value="ACTIVE">Hoạt động</option>
                                        <option value="INACTIVE">Khóa</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                <button
                                    style={{minWidth: "fit-content", marginRight: "10px"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.createFeeItem()}
                                >
                                        <span className='justify-content-center'>
                                            Lưu
                                        </span>
                                </button>
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Đóng
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
export default ModalCreateFeeItem